import { Component, ElementRef, HostBinding, Input, OnInit, ViewChild } from '@angular/core';

import { RelatedCard } from '@ridango/core';

@Component( {
    selector: 'ridango-dropdown-related-card-item',
    templateUrl: './dropdown-related-card-item.component.html',
    styleUrls: [ './dropdown-related-card-item.component.css' ]
} )
export class DropdownRelatedCardItemComponent implements OnInit {
    @Input() item: RelatedCard;
    @Input() isSelected = false;
    @Input() id: string;

    @ViewChild('listItem', {static: true}) listItem: ElementRef;

    constructor() { }

    @HostBinding('attr.role') role = 'none';

    ngOnInit () { }

    focus(): void {
        setTimeout(() => this.listItem.nativeElement.focus());
    }

}
